<template>
    <div style="overflow-y: auto;" class="container">
        <div class="text-box">
            <span>城市：</span>
            <p>{{tableData.city.name}}</p>
        </div>
        <div class="text-box">
            <span>总数量：</span>
            <p class="text">{{tableData.total_count}}</p>
        </div>
        <div class="text-box">
            <span>剩余数量：</span>
            <p class="text">{{tableData.surplus_count}}</p>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'msgCountDetails',
        data() {
            return {
                tableData: []
            };
        },
        created() {
            this.$post(
                '/msg/getMsgCountDetails'
            ).then((res) => {
                console.log(res.data);
                this.tableData = res.data;
            });
        }
    };

</script>

<style scoped>
.text-box{
    display: flex;
    width: 400px;
    margin: 10px auto;
}
.text-box span{
    display: block;
    width: 100px;
    text-align: right;
}
.text-box p{
    width: 300px;
}

.text {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #ff7606 !important;
}
</style>